module.exports = __webpack_public_path__ + "img/74.33b045b.png";